import { z } from 'zod'

import { zSortDirectionEnum } from '@/schemas/sortDirectionEnumSchema'

export const zPagination = z.object({
  totalPages: z.optional(z.int()).default(0),
  totalResults: z.optional(z.int()).default(0),
  page: z.optional(z.int().gte(0).lte(2147483647)).default(0),
  pageSize: z.optional(z.int().gte(0).lte(2147483647)).default(25),
  sortBy: z.nullable(
    z
      .string()
      .min(0)
      .max(255)
      .regex(/^[0-9a-zA-Z._-]+$/)
  ),
  sortDirection: z.nullable(zSortDirectionEnum),
})

export type PaginationSchema = z.infer<typeof zPagination>
